import { useFormBuilderContextState } from 'components/FormBuilder/context';
import { RadioErrors } from 'components/FormBuilder/schemas';

import { isDropdownDataField } from './helpers';

export const useDropdownDataField = () => {
  const { values, errors, ...rest } = useFormBuilderContextState();

  if (!isDropdownDataField(values)) {
    throw new Error(
      `useDropdownDataField must be used where a dropdown input is expected, instead input of type: ${values.type} was received.`,
    );
  }

  return {
    ...rest,
    values,
    errors: errors as RadioErrors,
  };
};
